import Accordion from 'entities/Accordion'
import { BookingLimitTR } from 'features/_TableReservationFeatures/BookingLimitTR'
import { ColorPickerTR } from 'features/_TableReservationFeatures/ColorPickerTR'
import { FontPickerTR } from 'features/_TableReservationFeatures/FontPickerTR'
import { CheckboxesTR } from 'features/_TableReservationFeatures/AdditionalTROptions'
import { ThemeSelectorTR } from 'features/_TableReservationFeatures/ThemeSelector'
import { LogoImagePickerTR } from 'features/_TableReservationFeatures/LogoImageTR'

export const ReservationInterface = () => {
  return (
    <Accordion title='Reservation interface design' defaultExpanded>
      <BookingLimitTR />
      <LogoImagePickerTR />
      <FontPickerTR />
      <ColorPickerTR />
      <ThemeSelectorTR />
      <CheckboxesTR />
    </Accordion>
  )
}
